import style from "./form.module.scss";

function SelectInput({ label, options, onChange, allowEntry, valueState }) {

    return (
        <div className={style.input_cnt}>
            <label>{label}</label>
            <select className="clearselect" required value={valueState.value} onChange={(e) => {  valueState.setValue(e.target.value); onChange && onChange(e.target.value);}} disabled={!allowEntry} >

                <option hidden value="">{`Choose option`}</option>

                {(options?.length > 0) ? options.map(option => {
                    return <option value={option} key={option}>{option}</option>
                })
                :
                <option disabled value=""> {(label=="Location")?"Choose region first":"loading..."}</option>}

            </select>
        </div>
    );
}

export default SelectInput;